import { ApiResourceBaseClass as i } from "./baseApiCalls.js";
const a = "api_keys";
class c extends i {
  /**
   * Fetches the list of API keys.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api_keys`
   *
   * @param {string} queryFilter - The query filter to apply to the API keys list.
   * @returns {Promise<ApiKeysData>} The list of API keys that match the provided query filter.
   */
  getApiKeys = async (t) => {
    const { data: e } = await this.get(`${a}?${t}`);
    return e;
  };
  /**
   * Revokes an API key.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api_keys/revoke/:keyId`
   *
   * @param {number} keyId - The API key id to revoke.
   * @returns {Promise<ApiKeysData>} The details of the API key that was revoked.
   */
  revokeApiKey = async (t) => {
    const { data: e } = await this.post(`${a}/revoke/${t}`);
    return e;
  };
  /**
   * Gets the value of an API key.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api_keys/key/:keyId`
   *
   * @param {number} keyId - The API key id to get the value of.
   * @returns {Promise<ApiKeyValue>} The value of the API key that was requested.
   */
  getApiKeyKeyValue = async (t) => {
    const { data: e } = await this.get(`${a}/key/${t}`);
    return e;
  };
  /**
   * Edits an API key.
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/api_keys/:keyId`
   *
   * @param {number} keyId - The API key id to edit.
   * @returns {Promise<ApiKeysData>} The details of the API key that was edited.
   */
  editApiKey = async (t, e) => {
    const { data: s } = await this.put(`${a}/${t}`, e);
    return s;
  };
  /**
   * Creates an API key.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api_keys/:keyId`
   *
   * @param {ApiKeyPayload} payload - The details of the API key to create.
   * @returns {Promise<ApiKeysData>} The details of the API key that was created.
   */
  createApiKey = async (t) => {
    const { data: e } = await this.post(`${a}`, t);
    return e;
  };
}
export {
  c as ApiKeys
};
